import clsx from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const merge = extendTailwindMerge({
  separator: '_',
});

export const cn = (...args) => merge(clsx(...args));
